// src/components/settings/settings-modal.ts
import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { apiService } from '../../services/api-service'

@customElement('settings-modal')
export class SettingsModal extends LitElement {
    @property({ type: Boolean, reflect: true }) open = false
    @property({ type: String }) title = 'Settings'

    static styles = css`
        :host {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.5);
        }

        :host([open]) {
            display: block;
        }

        .modal-container {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .modal-box {
            background-color: var(--bg-primary);
            width: min(600px, 100% - var(--s2));
            max-height: min(400px, 100% - var(--s2));
            border-radius: var(--radius-medium);
            overflow: hidden;
            position: relative;
        }

        .modal-close {
            position: absolute;
            top: var(--s1);
            right: var(--s1);
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            color: var(--text-primary);
            z-index: 2;
        }

        .modal-content {
            overflow-y: auto;
        }
    `

    close() {
        this.open = false
        this.dispatchEvent(new CustomEvent('modal-closed'))
    }

    private _resetSession() {
        if (
            confirm(
                'Are you sure you want to reset your session? This will clear all your conversations.',
            )
        ) {
            apiService.logout().subscribe(() => {
                window.location.reload()
            })
        }
    }

    render() {
        return html`
            <div
                class="modal-container"
                @click="${(e: { target: any; currentTarget: any }) => {
                    if (e.target === e.currentTarget) this.close()
                }}"
            >
                <e-box class="modal-box">
                    <button class="modal-close" @click="${this.close}">×</button>

                    <e-cover minHeight="auto" space="var(--s1)">
                        <e-text textType="heading">${this.title}</e-text>

                        <div class="modal-content" centered>
                            <slot></slot>
                        </div>

                        <e-cluster justify="space-between">
                            <e-button variant="playful" @click="${this._resetSession}">
                                Reset App State
                            </e-button>
                            <e-button @click="${this.close}">Close</e-button>
                        </e-cluster>
                    </e-cover>
                </e-box>
            </div>
        `
    }
}
